document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header');

  if (header) {
    let lastScrollTop = 0;
    window.addEventListener('scroll', function() {
      const scrollTop = window.scrollY;
      if (scrollTop == 0) {
        header.classList.remove('scroll-up', 'scroll-down');
      } else if (scrollTop < lastScrollTop) {
        header.classList.add('scroll-up');
        header.classList.remove('scroll-down');
      } else {
        header.classList.add('scroll-down');
        header.classList.remove('scroll-up');
      }
      lastScrollTop = scrollTop;
    });
  }
});